<template>
  <div>
    <button
      class="btn btn-primary full mb-3 radius-0 f13 h-100"
      @click="add"
    >
      Add Prova
    </button>

    <div
      v-for="(evaluation, key) in evaluations"
      :key="key"
    >
      <EvaluationForm
        class="mt-3 pb-3"
        :evaluation="evaluation"
        :job_id="job_id"
      />
    </div>
  </div>
</template>

<script>
import EvaluationForm from "pages/Recruiters/Evaluations/Form.vue";
export default {
  props: {
    job_id: {
      type: Number,
      required: true,
    },
  },
  components: { EvaluationForm },
  data: () => ({
    evaluations: [],
  }),
  mounted() {
    if (this.job_id) {
      this.getEvaluations();
    }
  },
  methods: {
    add() {
      this.evaluations.push({ name: "", description: "", id: null });
    },
    getEvaluations() {
      axios
      .get("/recruiters/evaluations?job_id=" + this.job_id)
      .then((response) => {
        this.evaluations = response.data.evaluations;
        if (this.evaluations.length == 0) {
          this.add();
        }
      });
    },
  },
  watch: {
    job_id() {
      if (this.job_id) {
        this.getEvaluations();
      }
    },
  }
};
</script>

<style>
</style>